import styled from "styled-components";

export const Circle = styled.div`
  width: ${props => props.size || 20}px;
  height: ${props => props.size || 20}px;
  border-radius: 100%;
  background-color: ${props => props.color || 'black'};
`;